export default class Contact {
    public id: string | null = null
    public companyId: string | null = null
    public salutation = ""
    public firstName = ""
    public lastName = ""
    public email = ""
    public searchTerms = ""
}
